import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { getAuthToken } from 'datastage/utils/localStorageService.js';
import { fetchUserPermissions, logout } from '../../datastage/store/auth';

export function SecuredApp({ App }) {
    const { auth } = useSelector((s) => s);
    const token = getAuthToken();
    const [isAuth, setIsAuth] = useState(!!token);
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const location = useLocation();

    useEffect(() => {
        checkCredentials();
        // eslint-disable-next-line
    }, []);

    useEffect(() => {
        giveAccess();
        // eslint-disable-next-line
    }, [token]);

    function checkCredentials() {
        if (token?.length) dispatch(fetchUserPermissions(token));
    }

    function giveAccess() {
        if (token) {
            setIsAuth(true);
        } else if (!token) {
            let loginPath = '/login';
            if (location.pathname !== '/login') {
                const target = location.pathname + location.search;
                loginPath = `/login?postLoginRedirect=${encodeURIComponent(target)}`;
            }
            dispatch(logout());
            setIsAuth(false);
            navigate(loginPath);
        }
    }

    if (isAuth) {
        return <App />;
    }
    return <h1>Redirecting...</h1>;
}
